import { render, staticRenderFns } from "./activity-dragon-boat.vue?vue&type=template&id=caa94ae6&scoped=true&"
import script from "./activity-dragon-boat.vue?vue&type=script&lang=js&"
export * from "./activity-dragon-boat.vue?vue&type=script&lang=js&"
import style0 from "./activity-dragon-boat.vue?vue&type=style&index=0&id=caa94ae6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa94ae6",
  null
  
)

export default component.exports